import React from 'react';
import { useTranslation } from 'react-i18next';

import EmptyData from 'components/EmptyData';

import ClockSvg from '@common/assets/icons/clock.svg';
import { getPluralKey } from '@common/helpers/getPluralKey';
import useCountDown from '@common/helpers/useCountDown';
import { IStudentLessonModel } from '@common/models/StudentLessons/Studentlesson';

import LessonTimePlaceholderNumberBlock from './NumberBlock';
import { StyledLessonTimePlaceholderDateWrap } from './styled';

interface PropsType {
	lessonModel: IStudentLessonModel;
}

function LessonTimePlaceholder({ lessonModel }: PropsType) {
	const { t } = useTranslation();
	const { days, hours, minutes, seconds } = useCountDown(lessonModel.lessonStartDate, () =>
		lessonModel.fetch(),
	);

	return (
		<EmptyData title={t('lesson.emptyTitle')} icon={<ClockSvg />}>
			<StyledLessonTimePlaceholderDateWrap>
				<LessonTimePlaceholderNumberBlock
					value={days}
					label={t(`shared.days.${getPluralKey(days)}`)}
				/>
				<LessonTimePlaceholderNumberBlock
					value={hours}
					label={t(`shared.hours.${getPluralKey(hours)}`)}
				/>
				<LessonTimePlaceholderNumberBlock
					value={minutes}
					label={t(`shared.minutes.${getPluralKey(minutes)}`)}
				/>
				<LessonTimePlaceholderNumberBlock
					value={seconds}
					label={t(`shared.seconds.${getPluralKey(seconds)}`)}
				/>
			</StyledLessonTimePlaceholderDateWrap>
		</EmptyData>
	);
}

export default LessonTimePlaceholder;
